import Dashboard from './Dashboard';

const path = '/dashboard';

export const redirects = [];

const routes = [
  {
    path: `${path}`,
    icon: '',
    component: Dashboard,
    exact: true,
  },
];

export default routes;
